export default "__VITE_ASSET__e$BMJ3_N__"